'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ForecastsMenu = require('./ForecastsMenu');

var _ForecastsMenu2 = _interopRequireDefault(_ForecastsMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ForecastsMenu2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/ForecastsMenu/index.js
// module id = 588
// module chunks = 11